// removed by extract-text-webpack-plugin
module.exports = {"component":"_2fb2seai4wb3u3jc3QIYs1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExitPopUp/exitPopUp.css
// module id = 1226
// module chunks = 2